import { ElfsightWidget } from 'react-elfsight-widget'

const HelpButton = ({ }) => {
    return <ElfsightWidget widgetID='d8edc501-89be-490f-b875-1bcd49ffa2d1'/>
};

export default HelpButton;